import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import injectTapEventPlugin from 'react-tap-event-plugin';
import {isCordovaApp, isTouchDevice} from './utils/Browser';

// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
if (isTouchDevice()) {
    console.log('Injecting TapEventPlugin');
    injectTapEventPlugin({
        // This ignores ghost clicks and makes sure we don't rely on onClick exclusively.
        shouldRejectClick: function (lastTouchEventTimestamp, clickEventTimestamp) {
            return true;
        }
    });
}

if (isCordovaApp()) {
    document.addEventListener("deviceready", () => {
        ReactDOM.render((<Routes/>), document.getElementById('root'));
    }, false);
} else {
    ReactDOM.render((<Routes/>), document.getElementById('root'));
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/